<template>
  <vs-table ref="table" :data="data" :noDataText="theNoDataText">
    <template slot="thead">
      <vs-th sort-key="name" scope="col" width="30%">Work Experience</vs-th>
      <vs-th sort-key="name" scope="col" width="10%">Type</vs-th>
      <vs-th sort-key="email" scope="col" width="15%">Date Completed</vs-th>
      <vs-th sort-key="popularity" scope="col" width="15%">Certificate Status</vs-th>
      <vs-th sort-key="popularity" scope="col" width="15%">Date</vs-th>
      <vs-th scope="col" width="15%">Action</vs-th>
    </template>

    <template slot-scope="{ data }">
      <tbody class="whitespace-no-wrap">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="{ hoverFlat: false }"
        >
          <vs-td scope="row">
            <p class="product-name font-medium truncate">
              <router-link :to="'work-experience/' + tr.id + '/introduction'" v-if="tr.type == 1">{{
                tr.vje
              }}</router-link>
              <router-link :to="'work-experience/' + tr.id + '/experience-info'" v-else>{{
                tr.vje
              }}</router-link>
            </p>
          </vs-td>
          <vs-td>
            <vs-chip color="danger" v-if="tr.type == 1">Virtual</vs-chip>
            <vs-chip color="primary" v-else>Real World</vs-chip>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.date }}</p>
          </vs-td>
          <vs-td>
            <vs-chip :color="getStatusColor(tr.certificate_status)" class="product-order-status">{{
              tr.certificate_status_text
            }}</vs-chip>
          </vs-td>
          <vs-td>
            <p class="product-category" v-if="tr.certificate_status == 0">-</p>
            <p class="product-category" v-if="tr.certificate_status == 1">
              {{ tr.certificate_date_requested }}
            </p>
            <p class="product-category" v-if="tr.certificate_status == 2">
              {{ tr.certificate_date_approved }}
            </p>
            <p class="product-category" v-if="tr.certificate_status == 3">
              {{ tr.certificate_date_declined }}
            </p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <button
              class="btn btn-primary btn-size-small danger includedIcon"
              :aria-label="`Request Certificate for work experience in ${tr.vje}`"
              @click="requestCertificate(tr.id)"
              v-if="tr.certificate_status == 0"
              :disabled="tr.is_certificate_requested"
            >
              <file-plus-icon />Request Certificate
            </button>
            <button
              class="btn btn-primary btn-size-small includedIcon"
              :aria-label="`View Certificate for work experience in ${tr.vje}`"
              @click="viewCertificate(tr.id)"
              v-if="tr.certificate_status == 2"
            >
              <download-icon />View Certificate
            </button>
          </vs-td>
        </vs-tr>
      </tbody>
    </template>
  </vs-table>
</template>

<script>
import store from '@/store/store';
import { FilePlusIcon, DownloadIcon } from 'vue-feather-icons';

export default {
  components: {
    FilePlusIcon,
    DownloadIcon,
  },
  props: ['data', 'noDataText'],
  inject: ['requestCertificate'],
  methods: {
    viewCertificate(vje_id) {
      const item = this.data.find((i) => i.id == vje_id);
      if (item) {
        // Certificates live in private storage, so certificate_url arrives already signed.
        store.dispatch('popup/showIframePopup', {
          src: item.certificate_url,
          title: `${item.vje} certificate`,
        });
      }
    },
    getStatusColor(status) {
      if (status == 0) return 'dark';
      else if (status == 1) return 'danger';
      else if (status == 2) return 'success';
      else if (status == 3) return 'dark';
    },
  },
  computed: {
    theNoDataText() {
      if (this.$props.noDataText != '') return this.$props.noDataText;
      else return 'No Data Available';
    },
  },
};
</script>
